import { Formik } from 'formik';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  LoggedOutScreenSubtitle,
  LoggedOutScreenTitle,
  LoggedOutScreenWrapper,
} from '../../LoggedOutScreenWrapper';
import { UserDetails } from '../SignUp';
import i18n from '../../../i18n/config';
import { SignUpWithSSOButton } from '../SignUpWithSSOButton';
import EmailInputForm from './EmailInputForm';
import { useGetRegistrationMethods } from './RegistrationFlow/hooks/useGetRegistrationMethods';
import { RegistrationMethod } from './RegistrationFlow/constants';

export const ResponseMessageTypes = {
  'validate-workplace-email-not-recognised': i18n.t(
    'logged_out:sign_up.forms.work_email.errors.unrecognised_email',
  ),
  fallback: i18n.t('shared:errors.messages.failed'),
} as const;

export interface WorkEmailFormProps {
  onSubmit(details: UserDetails): void;
  isInitialValid?: boolean;
  initialValues?: { email: string };
  error?: string;
}

interface FormFields {
  emailInput: string;
}

const EnterWorkEmailForm = ({
  initialValues = { email: '' },
  isInitialValid = false,
  error,
  onSubmit,
}: WorkEmailFormProps) => {
  const formikRef = useRef<Formik<FormFields>>(null);
  const { t: translate } = useTranslation('logged_out');
  const [formError, setFormError] = useState('');
  const { registrationMethods } = useGetRegistrationMethods();

  return (
    <LoggedOutScreenWrapper dataTestId="signup-email-form">
      <LoggedOutScreenTitle data-testid="form-title">
        {translate('sign_up.forms.work_email.heading')}
      </LoggedOutScreenTitle>
      <LoggedOutScreenSubtitle data-testid="form-subtitle">
        {translate('sign_up.forms.work_email.subtitle')}
      </LoggedOutScreenSubtitle>
      <EmailInputForm
        isInitialValid={isInitialValid}
        initialValues={{
          emailInput: initialValues.email,
        }}
        onSubmit={() => {
          onSubmit({
            email: formikRef?.current?.state.values.emailInput,
          });
        }}
        setError={setFormError}
        error={error || formError}
        formikRef={formikRef}
      />
      {registrationMethods.includes(RegistrationMethod.SSO) && (
        <SignUpWithSSOButton />
      )}
    </LoggedOutScreenWrapper>
  );
};

export default EnterWorkEmailForm;
